import { SearchBaseModel } from '../commonModels';

export class ProducerSearchModel extends SearchBaseModel {

  constructor() {
    super();
    this.ProducerId = null;
    }

  public ProducerId: number;
}

export class BrandSearchModel extends SearchBaseModel {

  constructor() {
    super();
    this.BrandId = null;
    }

  public BrandId: number;
}

export class BrandManagamentSearchModel extends SearchBaseModel {
  public Brand: string;
  public Producer: string;
  public TyreSegmentId: number;
  public BrandId: number;
  public ProducerId: number;

  constructor() {
    super();
    this.Brand = null;
    this.Producer = null;
    this.TyreSegmentId = null;
    this.BrandId = null;
    this.ProducerId = null;
    }
}

